import React, { Component } from "react";
import moment from "moment";
import DateRangePicker from "../Invoice/DateRangePicker";
import { Grid } from "@mui/material";
import Loader from "../../Layout/Loader";
import GarageSelector from "../GarageInvoices/GarageSelector";
import Scrollbar from "react-scrollbars-custom";
import Button from "../common/Button";
import { GetApp } from "@mui/icons-material";

export default class GaragePaymentFilter extends Component {
  state = {
    from: "",
    to: "",
    selectedDate: "",
    selectedaccountId: "",
    isSubmitBtn: false,
    contractNumber: [],
  };

  showDates = (e, date) => {
    const adjustedEndDate = date.endDate
      .clone()
      .set({ hour: 23, minute: 59, second: 59, millisecond: 999 });
    const timezone =
      this.props.logInUser?.attributes?.timezone ||
      this.props.ServerSetting?.attributes?.timezone ||
      "Asia/Riyadh";
    moment.tz.setDefault(timezone);
    const timeFormat = this.props.logInUser?.twelveHourFormat ? "hh:mm A" : "HH:mm";
    this.setState(
      {
        selectedDate:
          moment(date.startDate).format("YYYY-MM-DD " + timeFormat) +
          " - " +
          adjustedEndDate.format("YYYY-MM-DD " + timeFormat),
        from: moment(date.startDate.format("YYYY-MM-DD HH:mm")).toISOString(),
        to: adjustedEndDate.toISOString(),
      },
      this.handleSubmitBtn
    );
  };

  handleChangeGarage = (name) => {
    const selected = Array.isArray(name) ? name : [];
    let filter = "";
    Object.entries(selected).forEach(([, value]) => {
      if (value) filter += `&garageId=${value}`;
    });
    this.setState(
      {
        contractNumber: selected,
        selectedaccountId: filter,
      },
      this.handleSubmitBtn
    );
  };

  handleSubmitBtn = () => {
    const hasDate = !!(this.state.to && this.state.from);
    if (this.props.showPayments) {
      this.setState({ isSubmitBtn: hasDate });
      return;
    }
    this.setState({ isSubmitBtn: hasDate && !!this.state.selectedaccountId });
  };

  getEffectiveGarageFilter = () => {
    if (this.props.showPayments) {
      const selectedGarageId =
        this.props.selectedAccount?.garageId || this.props.selectedAccount?.id || "";
      return selectedGarageId ? `&garageId=${selectedGarageId}` : "";
    }
    return this.state.selectedaccountId;
  };

  submit = (type = "") => {
    const selectedaccountId = this.getEffectiveGarageFilter();
    if (type === "downloadExcel" || type === "downloadPdf") {
      this.props.downloadInvoices(
        this.state.to,
        this.state.from,
        selectedaccountId,
        "",
        "",
        type
      );
      return;
    }
    this.props.paymentFilter(this.state.to, this.state.from, selectedaccountId, "", "");
  };

  render() {
    const viewScreen = (
      <form style={{ padding: "16px 0 16px 10px" }}>
        <Grid container className="form-group sidebar-bg-layer">
          <Grid item xs={12} style={{ padding: 10 }}>
            <DateRangePicker
              fill
              error={this.props.timeError || false}
              selectedDate={this.state.selectedDate}
              label={
                this.props.translate("reportFrom") +
                " " +
                this.props.translate("reportTo")
              }
              onEvent={this.showDates}
            />
          </Grid>
          {!this.props.showPayments && (
            <Grid item xs={12} style={{ padding: 10 }}>
              <GarageSelector
                {...this.props}
                fill
                hideIcons
                isClearable
                placeholder={this.props.translate("searchGarage")}
                onChange={this.handleChangeGarage}
                value={this.state.contractNumber}
              />
            </Grid>
          )}
          <Grid item xs={12} style={{ padding: 10 }}>
            <div style={{ display: "flex", justifyContent: "center", margin: 20 }}>
              <Button
                disabled={this.state.isSubmitBtn ? "" : "disabled"}
                variant="contained"
                color="primary"
                onClick={() => this.submit("downloadExcel")}
                style={{ margin: 5, height: "30px", width: "60px" }}
              >
                <GetApp />
                {this.props.translate("Excel")}
              </Button>
              <Button
                disabled={this.state.isSubmitBtn ? "" : "disabled"}
                onClick={() => this.submit("")}
                style={{ margin: 5, height: "30px", width: "60px" }}
              >
                Submit
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    );

    return (
      <div className="geofence-sidebar-list">
        {!this.props.loader ? <Scrollbar>{viewScreen}</Scrollbar> : <Loader component="filter" />}
      </div>
    );
  }
}
